import { Reducer } from 'react';
import { Actions } from '../../actions/carrierList';
import { Action, CarrierListState } from '../../types';

const initialCarrierListState: CarrierListState = {
    searchPhrase: '',
    compliantStatus: '',
};

const setSearchPhrase = (search: string, state: CarrierListState): CarrierListState => {
    return {
        ...state,
        searchPhrase: search,
    };
};

const setCompliantStatus = (compliantStatus: string, state: CarrierListState): CarrierListState => {
    return {
        ...state,
        compliantStatus: compliantStatus,
    };
};

const carrierListReducer: Reducer<CarrierListState, Action> = (state, action): CarrierListState => {
    // var newState = { ...state };
    let newState = { ...state };
    switch (action.type) {
        case Actions.UPDATE_SEARCH_PHRASE:
            newState = setSearchPhrase(action.payload, state);
            break;
        case Actions.UPDATE_COMPLIANT_STATUS:
            newState = setCompliantStatus(action.payload, state);
            break;
    }

    return newState;
};

export { initialCarrierListState, carrierListReducer };
